import {
  Modal,
  ModalBody,
  ModalTitle,
  ModalProps,
  ModalFooter,
  ModalDescription,
  ModalFooterProps
} from './components';

/**
 * Basic modal component with a title, description, children, and footer actions with 2 cancel and submit buttons.
 */
export interface BaseModalProps extends Partial<Omit<ModalProps, 'title' | 'onSubmit'>> {
  asChild?: boolean; // Helpful prop when using the form inside the modal
  title?: React.ReactNode;
  footer?: ModalFooterProps;
  description?: React.ReactNode;
}

export const BaseModal = ({
  title,
  footer,
  asChild,
  children,
  className,
  description,
  ...restProps
}: BaseModalProps) => (
  <Modal {...restProps}>
    {title ? <ModalTitle>{title}</ModalTitle> : null}
    {description ? <ModalDescription>{description}</ModalDescription> : null}
    {asChild ? (
      children
    ) : (
      <>
        {children ? <ModalBody>{children}</ModalBody> : null}
        {footer ? <ModalFooter {...footer} /> : null}
      </>
    )}
  </Modal>
);
